import FeaturingRoute from './FeaturingRoute';

export default FeaturingRoute;
